@if (component && !(isFacet && component.showCarouselOnFacets === 'hide')) {
<!-- div needed for iCMS component hide, don't remove -->
<div>
    <div class="p-t-4-s p-t-4-m p-b-4-s p-b-4-m p-r-0-s p-r-0-m p-r-0-l p-r-0-x"
         [ngClass]="isMinibasket ? 'p-t p-b' : isFullWidth ? 'wrap' : 'wrap flex-l flex-x'">
        <!-- text -->
        <div class="w-12-m w-12-s left flex-column"
             [ngClass]="(isMinibasket || isFullWidth) ? 'w-12' : 'w-3'">
            <span class="p-b-2 h2"
                  *iCms="'title' of component">
            </span>
            <span class="w-11 p-b-2 p1 text"
                  *iCms="'copy' of component; content: 'html'; skipEmpty: true">
            </span>
            @if (component?.cta_copy) {
            <span class="p-b-6 left">
                <href class="button-inline"
                      [link]="component.cta_link"
                      *iCms="'cta_copy' of component">
                </href>
            </span>
            }
        </div>
        <!-- slides -->
        <div class="w-12-m w-12-s"
             [ngClass]="(isMinibasket || isFullWidth) ? 'w-12' : 'w-9'">
            <div class="_swiper-container pos-relative overflow-hidden"
                 [style.--pc-slides-ceil]="pcSlidesCeil"
                 [style.--pc-slides]="pcSlides"
                 [style.--pc-gutter]="pcGutter"
                 [style.--padding-left-wrap.px]="[16,32,40,40][client.sizeId]"
                 [style.--width]="isMinibasket ? undefined : (isFullWidth || client.isS || client.isM ? 1 : 0.75)"
                 [style.--ratio]="variant === variantTypes.range ? 1/2 : 1/1">
                <div class="fill">
                    <carousel class="_swiper"
                              [slidesPerView]="'auto'"
                              [navigation]="false"
                              [scrollbar]="false"
                              [pagination]="false"
                              [loopedSlides]="loopedSlides"
                              [loop]="isFullWidth"
                              [navigation]="{
                                nextEl: '.carousel-next-' + uid,
                                prevEl: '.carousel-prev-' + uid
                              }"
                              imageViewRoot>
                        @for (item of elements; track item) {
                        <ng-template swiperSlide>
                            @if (variant === variantTypes.category || variant === variantTypes.categorySmallSquares ||
                            variant
                            === variantTypes.categoryCircles) {
                            <href [link]="item.isAnchorLink ? undefined : item.url">
                                <div class="ratio-1-1 flex flex-justify-center flex-middle overflow-hidden"
                                     (click)="item.isAnchorLink ? scrollToId(item.anchorId) : null">
                                    <local-shell />
                                    <img [dfImage]="item.image"
                                         [ngStyle]="{'border-radius' : variant === variantTypes.categoryCircles ?  '50%' : '0' }"
                                         [priority]="$index < slidesPerView"
                                         ratio="1"
                                         [sizes]="['20vw', '22vw', '10vw', '10vw']"
                                         fill />
                                    <span class="col-w h4-s h4-m category-title z-1"
                                          [ngClass]="isMinibasket ? 'h4' : 'h3'"
                                          *iCms="'category_title' of item; content: 'html'"></span>
                                    <div class="category-subtitle flex-column z-1">
                                        <span class="col-w s2-s s2-m z-1"
                                              [ngClass]="isMinibasket ? 's2' : 's1'"
                                              *iCms="'category_subtitle' of item; content: 'html'"></span>
                                        <span class="col-w p2 p-t-1"
                                              *iCms="'category_subtitle_line_2' of item; content: 'html'">
                                        </span>
                                    </div>
                                </div>
                            </href>
                            }
                            @if (variant === variantTypes.range) {
                            <href [link]="item.isAnchorLink ? undefined : item.url">
                                <div class="ratio-2-1 flex flex-justify-center flex-middle overflow-hidden"
                                     (click)="item.isAnchorLink ? scrollToId(item.anchorId) : null">
                                    <local-shell />
                                    <img [dfImage]="item.image"
                                         [priority]="$index < slidesPerView"
                                         ratio="2/1"
                                         [sizes]="['20vw', '22vw', '10vw', '10vw']"
                                         fill />
                                </div>
                            </href>
                            }
                        </ng-template>
                        }
                        <!-- navigation arrows -->
                        <div slot="container-start">
                            <button class="pos-absolute top-50 left-4 z-5 _arrow"
                                    [ngClass]="'carousel-prev-' + uid"
                                    type="button"
                                    aria-label="Previous slide">
                                <i class="icon-chevron-left"
                                   aria-hidden="true"></i>
                            </button>
                            <button class="pos-absolute top-50 right-4 z-5 _arrow"
                                    [ngClass]="'carousel-next-' + uid"
                                    type="button"
                                    aria-label="Next slide">
                                <i class="icon-chevron-right"
                                   aria-hidden="true"></i>
                            </button>
                        </div>
                    </carousel>
                </div>
            </div>
        </div>
    </div>
</div>
}
